import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { clearStaleStorage } from "./utils/storageVersion";
import reportWebVitals from "./reportWebVitals";
import ErrorFallback from "components/ErrorFallback";
import { ErrorBoundary } from "react-error-boundary";

// NOW you can run code
clearStaleStorage();

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <ErrorBoundary FallbackComponent={ErrorFallback}>
    <React.StrictMode>
      <App />
    </React.StrictMode>
  </ErrorBoundary>,
);

reportWebVitals();
